import React, { useState, useEffect, useCallback } from 'react';
import { tasksAPI } from '../services/api';

const AttachmentView = ({ taskId }) => {
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadAttachments = useCallback(async () => {
    try {
      const response = await tasksAPI.getAttachments(taskId);
      setAttachments(response.data || []);
    } catch (err) {
      console.error('Error loading attachments:', err);
    } finally {
      setLoading(false);
    }
  }, [taskId]);

  useEffect(() => {
    loadAttachments();
  }, [loadAttachments]);

  const handleDelete = async (attachmentId) => {
    if (window.confirm('Are you sure you want to delete this attachment?')) {
      try {
        await tasksAPI.deleteAttachment(taskId, attachmentId);
        loadAttachments();
      } catch (err) {
        alert('Failed to delete attachment');
      }
    }
  };

  if (loading) {
    return <div>Loading attachments...</div>;
  }

  if (attachments.length === 0) {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Attachments</h3>
        </div>
        <p style={styles.empty}>No attachments</p>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Attachments</h3>
      </div>
      <div style={styles.gallery}>
        {attachments.map((attachment) => (
          <div key={attachment.id} style={styles.item}>
            {attachment.is_image ? (
              <div>
                <img
                  src={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/uploads/${attachment.file_path}`}
                  alt={attachment.filename}
                  style={styles.image}
                />
                <div style={styles.actions}>
                  <a
                    href={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/uploads/${attachment.file_path}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                  >
                    View
                  </a>
                  <button
                    onClick={() => handleDelete(attachment.id)}
                    style={styles.deleteButton}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ) : (
              <div style={styles.fileItem}>
                <span style={styles.filename}>{attachment.filename}</span>
                <div style={styles.actions}>
                  <a
                    href={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/uploads/${attachment.file_path}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                  >
                    Download
                  </a>
                  <button
                    onClick={() => handleDelete(attachment.id)}
                    style={styles.deleteButton}
                  >
                    Delete
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  gallery: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '1rem',
    marginTop: '1rem',
  },
  item: {
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '0.75rem',
    backgroundColor: '#f8f9fa',
    transition: 'all 0.2s ease',
  },
  image: {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
    borderRadius: '6px',
    marginBottom: '0.75rem',
    border: '1px solid #e5e7eb',
  },
  fileItem: {
    padding: '1rem',
    textAlign: 'center',
  },
  filename: {
    display: 'block',
    marginBottom: '0.75rem',
    fontSize: '0.875rem',
    wordBreak: 'break-word',
    color: '#374151',
    fontWeight: '500',
  },
  actions: {
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'center',
  },
  link: {
    padding: '0.5rem 1rem',
    backgroundColor: '#2563eb',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: '500',
    transition: 'all 0.2s ease',
  },
  deleteButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#dc2626',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: '500',
    transition: 'all 0.2s ease',
  },
  empty: {
    color: '#64748b',
    fontStyle: 'italic',
    textAlign: 'center',
    padding: '2rem',
  },
};

export default AttachmentView;
